import { NgModule } from '@angular/core';
import { ModuleHeaderComponent } from './module-header.component';
import { MenuModule } from 'primeng/menu';
import { TabMenuModule } from 'primeng/tabmenu';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [
    ModuleHeaderComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    MenuModule,
    TabMenuModule,
    DividerModule
  ],
  exports: [
    ModuleHeaderComponent
  ]
})
export class ModuleHeaderModule { }